// extracted by mini-css-extract-plugin
module.exports = {"arrow":"da51a739f7--arrow--naTE9"};